export const slickSwatches_productpage = () => {
  if (!$('.chanel-only').length > 0 && !$('.modal-quickview').length > 0) {
    const deviceWidth = window.innerWidth;
    const slickem = (that) => {
      if ($('.desktopPage').length > 0) {
        that.not('.slick-intialized').slick({
          prevArrow: '<i class="icon-arrow-left swatchCustomPrev slick-arrow" aria-hidden="true"></i>',
          nextArrow: '<i class="icon-arrow-right swatchCustomNext slick-arrow" aria-hidden="true"></i>',
          slidesToScroll: 1,
          infinite: false,
          variableWidth: true
        });
        that.css('margin-left', '20px');
        // that.css('width', '77%');
        if($('.preview-color-container').length > 0) {
          $('.preview-color-container .swatch-list').css('width', '77%');
        }
      } else if ($('.tabletPage').length > 0 && deviceWidth < 1366) {
        that.not('.slick-intialized').slick({
          arrows: false,
          infinite: false,
          slidesToShow: 6.5,
          slidesToScroll: 6,
        });
      } else if ($('.tabletPage').length > 0 && deviceWidth >= 1366) {
        that.not('.slick-intialized').slick({
          arrows: false,
          infinite: false,
          slidesToShow: 8.5,
          slidesToScroll: 8,
        });
      } else if ($('.mobilePage').length > 0 && deviceWidth >= 414 && deviceWidth < 1280) {
        that.not('.slick-intialized').slick({
          arrows: false,
          infinite: false,
          slidesToShow: 8.5,
          slidesToScroll: 8,
        });
      } else if ($('.mobilePage').length > 0 && deviceWidth >= 1280) {
        that.not('.slick-intialized').slick({
          arrows: false,
          infinite: false,
          slidesToShow: 9.5,
          slidesToScroll: 9,
        });
      } else {
        that.not('.slick-intialized').slick({
          arrows: false,
          infinite: false,
          slidesToShow: 6.5,
          slidesToScroll: 6,
        });
      }
      $('.slick-arrow').attr('tabindex', '0');
      $('.slick-arrow').on('keydown', function() {
        //Added for ADA purposes
        var arrowEnter = $(this);
        if (event.keyCode == 13) {
          arrowEnter.click();
        }
      });
    }

    const initialSwatchSlick = (colorChoice) => {

     if ($('.mobilePage').length > 0 && deviceWidth == 414) {
        $('.swatch-list').each(function() {
          if ($(this).find('li').length > 8)
            slickem($(this));
        });
      } else if ($('.desktopPage').length > 0) {
        $('.swatch-list').each(function() {
          if ($(this).find('li').length > 7)
            slickem($(this));
        });
      } else {
        $('.swatch-list').each(function() {
          if ($(this).find('li').length > 6)
            slickem($(this));
        });
      }

      $(colorChoice).on('change', function() {

        var selectVal = $(this).val(),
          imageColor = '';
        $(this).find('option').each(function() {
          var optionVal = $(this).val();
          if (selectVal == optionVal) imageColor = $(this).data('attrvalue');
        });
        let swatchImgs = ($('.product-item-attr-page').length > 0) ? $(this).parents('.form-group').find('.swatch-list li img') : $('.swatch-list li img');
        swatchImgs.each(function() {
          if ($(this).parents('li').hasClass('slick-slide')) {
          var slickImgColor = $(this).data('colorname');
          if (imageColor == slickImgColor) {
            $(this).parents('.slick-slide').addClass('slick-current');
            var liElem = $(this).parents('.slick-slide'),
              slickSlide = liElem.data('slick-index'),
              carousel = liElem.parents('.swatch-list');
              carousel.slick('slickGoTo', slickSlide);
          }
          }
        });
      });
    }
    if ($('.product-item-attr-page').length > 0) initialSwatchSlick('.color-select select');
    else {
      initialSwatchSlick('.color-select-group select');
      if ($('.item-select').length > 0 || $('.mobilePage').length > 0) {
        $('.item-select, .size-select').on('change', function() {
          setTimeout(function() {
            $('.swatch-list').each(function() {
              if ($(this).hasClass('slick-intialized')) {
              $(this).slick('unslick');
                slickem($(this));
              $(this).find('li img').each(function() {
                if ($(this).css('display') == 'none') $(this).parents('li').hide();
              });
              }
            });
          }, 500);
        });
      }
    }
  }
}
